jQuery(document).ready(function($) {

    var window_width = $(window).width();


    if(window_width <= 767 ){
        $(document).on('click','#menu-header-menu li a ',function(event) {
            var selector = $(this);
            var active_ul = selector.parent().find(".sub-menu")
            $(".sub-menu").not(active_ul).slideUp();
            active_ul.slideToggle();
        });
    }

    $(document).on('click','.read-more-content a',function(){
        var _self = $(this);
        var text_el = _self.parent().prev();
        if(text_el.hasClass('full')) {
            text_el.animate({height:'60px'},700).removeClass('full');
            _self.text('Read More');
        } else { 
            var height = text_el.get(0).scrollHeight;

            text_el.animate({height:height},700).addClass('full');
            _self.text('Read Less');
        }
    })

    $('.language a ').click(function(ev){
        var menu_item=  $(this).parent();
        if(menu_item.find('.language-menu').length){
          ev.preventDefault();
          var target = $(this).parent();
          target.toggleClass("open");
        }
    }) 

    $('.search i').on('click',function(){
        $('.header_search ').slideToggle();
    })

    $('.close_btn').on('click',function(){
        $('.header_search').removeClass('active');
    })

    /*setTimeout(function(){
        $('.radar_banner-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            fade: true,
            responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1
                  }
                }
            ]
        });
    },3000)*/
    /*$('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 4
              }
            }
        ]
    });*/
    

    var keep_scrolling = true;
    
    play_video_on_scroll();
    function play_video_on_scroll(){
        if($('.radar_video_sec.home-page-section').length){
            var video_block = document.getElementById("radar_video_block_tag");
            let scroll = $(window).scrollTop();
            let section_top = parseInt($('.radar_video_sec.home-page-section').offset().top) - 200;
            if(scroll > section_top && keep_scrolling){
                keep_scrolling = false;
                video_block.play();
            }
        }
        if($('.fellowship_logo_wrap.video-section').length){
            var video_block = $('#fellowship_logo_wrap_iframe');
            let scroll = $(window).scrollTop();
            let section_top = parseInt($('.fellowship_logo_wrap.video-section').offset().top) - 300;
            if(scroll > section_top && keep_scrolling){
                keep_scrolling = false;
                var videoURL = video_block.prop('src');
                videoURL = videoURL.replace(videoURL,videoURL+"?autoplay=1&mute=1");
                video_block.attr('src',videoURL);

            }
        }
    }
    $(window).on('scroll',function(){
        play_video_on_scroll();
    })

    var __slickLightbox = $('.radar_banner-slider').slickLightbox({
        itemSelector        : 'a',
        navigateByKeyboard  : true
    });
})


// WEBPACK FOOTER //
// ./src/assets/js/common.js